import { menu } from 'material-components-web';
import {MDCRipple} from '@material/ripple';

const categoryMenuToggle = document.querySelector(
  '.category-menu__title'
);

const categoryMenuList = document.querySelector('.category-menu__list')

if (categoryMenuToggle) {
  categoryMenuToggle.addEventListener('click', () => {
    if (categoryMenuList.style.maxHeight) {
      categoryMenuList.style.maxHeight = null;
      document.querySelector('.category-menu__title__more').style.transform = '';
      categoryMenuToggle.style.borderBottom = ''
      categoryMenuList.style.overflow = ''
    } else {
      categoryMenuList.style.maxHeight = categoryMenuList.scrollHeight + 'px'
      document.querySelector('.category-menu__title__more').style.transform = 'rotate(180deg)';
      categoryMenuToggle.style.borderBottom = 'none'
      categoryMenuList.style.overflow = 'auto'
    }
  })
}

const categoryMenuItemToggle = document.querySelectorAll('.menu-item-toggle')

categoryMenuItemToggle.forEach(element => {
  element.addEventListener('click', () => {
    if (element.querySelector('.plus').classList.contains('active')) {
      element.querySelector('.plus').classList.remove('active')
      element.querySelector('.minus').classList.add('active')

      element.closest('.item').nextElementSibling.classList.add('sub-menu-active')
    } else {
      element.querySelector('.plus').classList.add('active')
      element.querySelector('.minus').classList.remove('active')

      element.closest('.item').nextElementSibling.classList.remove('sub-menu-active')
    }

  })
});

// const subMenuItems = document.querySelectorAll('.sub-menu__deeper-menu__sub-menu__item')

// subMenuItems.forEach(element => {
//   if(element.querySelector('.sub-menu__deeper-menu__sub-menu__deepest')) {
//     element.querySelector('a').style.fontWeight = '500'
//   }
// })

const menuButton = document.querySelector(
  '.category-page__content__items__button .menu-button'
);
const categoryMenu = document.querySelector('.category-menu2');

if (menuButton && categoryMenu) {
  menuButton.addEventListener('click', () => {
    categoryMenu.style.visibility = 'visible'
    categoryMenu.style.opacity = '1';
    categoryMenu.style.display = 'block';
    categoryMenuList.style.display = 'block';
    document.body.style.overflow = 'hidden';
  })

  const closeMenu = function () {
    categoryMenu.style.visibility = ''
    categoryMenu.style.opacity = '';
    categoryMenuList.style.display = 'none';
    document.body.style.overflow = '';
  };

  document.querySelector('.category-menu__close__button').addEventListener('click', closeMenu);
}
